function getLocales(){var files=require.context('../locales',true,/\.js$/);var locales={};_.forEach(files.keys(),function(name){var lang=name.replace(/(.\/|.js)/g,'');locales[lang]=files(name).default});return locales}export default{locale:window.LOCALE,messages:getLocales()};


//////////////////
// WEBPACK FOOTER
// ./app/js/i18n.js
// module id = 200
// module chunks = 0